import { handleReceiveUsers } from './users';
import { showLoading, hideLoading } from 'react-redux-loading';

export default function handleReceiveData() {
  return dispatch => {
    dispatch(showLoading());
    dispatch(handleReceiveUsers());
    dispatch(hideLoading());
  };
}
